// ** Third Party Components
import { Check, Download, Edit, Edit2, Eye, Info, Trash, X } from 'react-feather'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Spinner } from 'reactstrap'
import toast from 'react-hot-toast'

import { Icon } from '@iconify/react'
import { setOpenModal } from '../store'
// ** Table Common Column

const SERVICES_DIGITAL_SIGNATURE = {
  '01': 'Api de Firma',
  '02': 'Portal completo'
}

const SERVICE_DIGITAL_FACTURA = {
  '01': 'Api de Facturación',
  '02': 'Portal de consultas',
  '03': 'Portal completo'
}

const CustomActions = ({ row }) => {
  const dispatch = useDispatch()

  const handleDelete = () => {
    console.log("ROW: ", row.id)
    return dispatch(setOpenModal({ type: 'delete', open: true, data: row.id }))

  }

  const handleEdit = () => {
    return dispatch(setOpenModal({ type: 'edit', open: true, data: row }))
  }

  return (
    <div className="d-flex align-items-center justify-content-center gap-1">
      <>
        <Button
          size="sm"
          outline
          className="cursor-pointer"
          onClick={handleEdit}
          color="primary"
        >
          <Edit />
        </Button>
        <Button
          size="sm"
          outline
          className="cursor-pointer"
          color="danger"
          onClick={handleDelete}
        >
          <Trash />
        </Button>
      </>
    </div>
  )
}

export const columns = () => [
  {
    name: 'Cliente',
    width: '7,5%',
    // center: true,
    selector: (row) => row.receiverName,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center text-center">{row.receiverName}</div>
    )
  },
  {
    name: 'Nombre comercial',
    width: '7,5%',
    // center: true,
    sortable: true,
    selector: (row) => row?.tradeName
  },
  {
    name: 'Documento',
    width: '7,5%',
    // center: true,
    sortable: true,
    selector: (row) => (row?.dteClientType?.value === "01" ? "DUI" : "NIT")
  },
  {
    name: 'N° documento',
    width: '7,5%',
    // center: true,
    sortable: true,
    selector: (row) => (row?.dteType?.value === "01" ? row.dui: row.nit)
  },
  {
    name: 'Documento a emitir',
    width: '7,5%',
    // center: true,
    sortable: true,
    selector: (row) => (row?.dteType?.label)
  },
  {
    name: 'Departamento',
    width: '7,5%',
    sortable: true,
    // center: true,
    selector: (row) => row?.department?.label
  },
  {
    name: 'Municipio',
    width: '7,5%',
    // center: true,
    sortable: true,
    selector: (row) => row?.municipality?.label
  },
  {
    name: 'Dirección',
    width: '7,5%',
    // center: true,
    sortable: true,
    selector: (row) => row?.address
  },
  {
    name: 'Actividad económica',
    width: '7,5%',
    center: true,
    cell: (row) => row?.economicActivity?.label
  },
  {
    name: 'Tipo contribuyente',
    width: '7,5%',
    center: true,
    cell: (row) => row?.largeConsumer?.label
  },
  {
    name: 'Correo electrónico',
    width: '7,5%',
    center: true,
    cell: (row) => row?.receiverEmail
  },
  {
    name: 'Teléfono',
    width: '7,5%',
    center: true,
    cell: (row) => row?.receiverPhoneNumber
  },
  {
    name: 'Acciones',
    width: '7,5%',
    // center: true,
    selector: '',
    cell: (row) => <CustomActions row={row} />
  }
]
